export default __webpack_public_path__ + "static/media/full.bfcbba29.JPG";